// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import PhotoType from "./photo-type.js"
import SheetLayout from "./sheet-layout.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "height_percent": {
      "column": {
        "default": null,
        "name": "height_percent",
        "null": false,
        "type": "decimal"
      },
      "name": "height_percent",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "left_percent": {
      "column": {
        "default": null,
        "name": "left_percent",
        "null": false,
        "type": "decimal"
      },
      "name": "left_percent",
      "selected_by_default": null,
      "translated": null
    },
    "photo_type_id": {
      "column": {
        "default": null,
        "name": "photo_type_id",
        "null": true,
        "type": "uuid"
      },
      "name": "photo_type_id",
      "selected_by_default": null,
      "translated": null
    },
    "sheet_layout_id": {
      "column": {
        "default": null,
        "name": "sheet_layout_id",
        "null": false,
        "type": "uuid"
      },
      "name": "sheet_layout_id",
      "selected_by_default": null,
      "translated": null
    },
    "top_percent": {
      "column": {
        "default": null,
        "name": "top_percent",
        "null": false,
        "type": "decimal"
      },
      "name": "top_percent",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "width_percent": {
      "column": {
        "default": null,
        "name": "width_percent",
        "null": false,
        "type": "decimal"
      },
      "name": "width_percent",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "SheetLayoutBox",
  "collectionKey": "sheet_layout_boxes",
  "collectionName": "sheet_layout_boxes",
  "i18nKey": "sheet_layout_box",
  "camelizedLower": "sheetLayoutBox",
  "name": "SheetLayoutBox",
  "nameDasherized": "sheet-layout-box",
  "pluralName": "sheet_layout_boxes",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoSheetProductBox",
      "collectionName": "photo_sheet_product_boxes",
      "foreignKey": "sheet_layout_box_id",
      "name": "photo_sheet_product_boxes",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductBox",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLineBox",
      "collectionName": "photo_sheet_product_order_line_boxes",
      "foreignKey": "sheet_layout_box_id",
      "name": "photo_sheet_product_order_line_boxes",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductOrderLineBox",
      "through": null
    },
    {
      "className": "PhotoType",
      "collectionName": "photo_types",
      "foreignKey": "photo_type_id",
      "name": "photo_type",
      "macro": "belongs_to",
      "resource_name": "PhotoType",
      "through": null
    },
    {
      "className": "SheetLayout",
      "collectionName": "sheet_layouts",
      "foreignKey": "sheet_layout_id",
      "name": "sheet_layout",
      "macro": "belongs_to",
      "resource_name": "SheetLayout",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "height_percent",
      "column": {
        "default": null,
        "name": "height_percent",
        "null": false,
        "type": "decimal"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "left_percent",
      "column": {
        "default": null,
        "name": "left_percent",
        "null": false,
        "type": "decimal"
      }
    },
    {
      "name": "photo_type_id",
      "column": {
        "default": null,
        "name": "photo_type_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "sheet_layout_id",
      "column": {
        "default": null,
        "name": "sheet_layout_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "top_percent",
      "column": {
        "default": null,
        "name": "top_percent",
        "null": false,
        "type": "decimal"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "width_percent",
      "column": {
        "default": null,
        "name": "width_percent",
        "null": false,
        "type": "decimal"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "PhotoType",
      "collectionName": "photo_types",
      "foreignKey": "photo_type_id",
      "name": "photo_type",
      "macro": "belongs_to",
      "resource_name": "PhotoType",
      "through": null
    },
    {
      "className": "SheetLayout",
      "collectionName": "sheet_layouts",
      "foreignKey": "sheet_layout_id",
      "name": "sheet_layout",
      "macro": "belongs_to",
      "resource_name": "SheetLayout",
      "through": null
    }
  ],
  "paramKey": "sheet_layout_box",
  "primaryKey": "id"
}

/** Frontend model for SheetLayoutBox. */
export default class SheetLayoutBox extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {number} */
  heightPercent() {
    return this.readAttributeUnderscore("height_percent")
  }

  /** @returns {boolean} */
  hasHeightPercent() {
    const value = this.heightPercent()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number} */
  leftPercent() {
    return this.readAttributeUnderscore("left_percent")
  }

  /** @returns {boolean} */
  hasLeftPercent() {
    const value = this.leftPercent()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  photoTypeId() {
    return this.readAttributeUnderscore("photo_type_id")
  }

  /** @returns {boolean} */
  hasPhotoTypeId() {
    const value = this.photoTypeId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  sheetLayoutId() {
    return this.readAttributeUnderscore("sheet_layout_id")
  }

  /** @returns {boolean} */
  hasSheetLayoutId() {
    const value = this.sheetLayoutId()

    return this._isPresent(value)
  }

  /** @returns {number} */
  topPercent() {
    return this.readAttributeUnderscore("top_percent")
  }

  /** @returns {boolean} */
  hasTopPercent() {
    const value = this.topPercent()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {number} */
  widthPercent() {
    return this.readAttributeUnderscore("width_percent")
  }

  /** @returns {boolean} */
  hasWidthPercent() {
    const value = this.widthPercent()

    return this._isPresent(value)
  }

  /** @returns {import("./photo-type.js").default | null} */
  photoType() {
    return this._readBelongsToReflection({modelClass: PhotoType, reflectionName: "photo_type"})
  }

  /** @returns {Promise<import("./photo-type.js").default | null>} */
  loadPhotoType() {
    if (!("photoTypeId" in this)) throw new Error("Foreign key method wasn't defined: photoTypeId")

    const id = this.photoTypeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_type",
        model: this,
        modelClass: PhotoType
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-type.js").default | null>} */
  ensurePhotoTypeLoaded() {
    return this.ensureAssociationLoaded("photo_type")
  }

  /** @returns {import("./sheet-layout.js").default | null} */
  sheetLayout() {
    return this._readBelongsToReflection({modelClass: SheetLayout, reflectionName: "sheet_layout"})
  }

  /** @returns {Promise<import("./sheet-layout.js").default | null>} */
  loadSheetLayout() {
    if (!("sheetLayoutId" in this)) throw new Error("Foreign key method wasn't defined: sheetLayoutId")

    const id = this.sheetLayoutId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "sheet_layout",
        model: this,
        modelClass: SheetLayout
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./sheet-layout.js").default | null>} */
  ensureSheetLayoutLoaded() {
    return this.ensureAssociationLoaded("sheet_layout")
  }
}
